// extracted by mini-css-extract-plugin
module.exports = {"uid":"u381a9c69"};